import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicModal, AcknowledgeErrors } from 'core/components';

function BaasicAcknowledgeErrorsTemplate({ modalParams }) {
    return (
        <BaasicModal modalParams={modalParams} className="modal__content modal--acknowledge">
            <AcknowledgeErrors
                initialErrors={modalParams.data.errors}
                onCancel={modalParams.onCancel}
            />
        </BaasicModal>
    );
}

BaasicAcknowledgeErrorsTemplate.propTypes = {
    modalParams: PropTypes.object
}

export default defaultTemplate(BaasicAcknowledgeErrorsTemplate);
